import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider, useAuth } from './auth';
import { setTokenGetter } from './lib/api-client';
import { AppRoutes } from './routes';

function TokenSync() {
  const { getAccessToken, login } = useAuth();

  useEffect(() => {
    setTokenGetter(getAccessToken);
  }, [getAccessToken]);

  useEffect(() => {
    const handleUnauthorized = (_event: Event) => {
      login(`${window.location.pathname}${window.location.search}`);
    };

    window.addEventListener('auth:unauthorized', handleUnauthorized);

    return () => {
      window.removeEventListener('auth:unauthorized', handleUnauthorized);
    };
  }, [login]);

  return null;
}

function AppInner() {
  return (
    <AuthProvider>
      <TokenSync />
      <AppRoutes />
    </AuthProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;
